module.exports = {"StatusCode":200,"Payload":[{"accountId":"acct_1CMoRVGKDn8KbSm1","accountLink":"https://stripe.com/docs/api/accounts/create?lang=node"}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/createStripeAccount.json
// module id = LyXE
// module chunks = 0